import { render, staticRenderFns } from "./FarmDetails.vue?vue&type=template&id=2bf8a3fb&scoped=true&"
import script from "./FarmDetails.vue?vue&type=script&lang=js&"
export * from "./FarmDetails.vue?vue&type=script&lang=js&"
import style0 from "./FarmDetails.vue?vue&type=style&index=0&id=2bf8a3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8a3fb",
  null
  
)

export default component.exports